import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Box } from './Box';
import { Loading } from './Control';
import { MobileContext } from './Context';
import { classnames, getOverWidth } from './Utils';

const _calWidth = w => {
	const WM = {
		full: '98%',
		lg: 1024,
		sd: 800,
		md: 720,
		sm: 600,
		xs: 360,
	};
	return _.isString(w) && _.includes(_.keys(WM), w) ? { width: WM[w] } : _calLength(w);
};

const _calLength = (src, type = 'width') => {
	const prop = type === 'width' ? 'width' : 'height';
	const result = {};
	const _transferPercent = (str) => {
		const percent = (str).toInt();
		if (_.isNumber(percent)) {
			const len = window.getSize()[type === 'width' ? 'x' : 'y'] * percent / 100;
			return _.isArray(src) ? (len < src[1] ? src[1] : len > src[2] ? src[2] : len) : len;
		}
		else return str;
	};
	if (_.isArray(src)) {
		if (src.length === 2) {
			result[`min${_.capitalize(prop)}`] = src[0];
			result[`max${_.capitalize(prop)}`] = src[1];
		}
		else if (src.length === 3) {
			result[prop] = _transferPercent(src[0]);
			result[`min${_.capitalize(prop)}`] = src[1];
			result[`max${_.capitalize(prop)}`] = src[2];
		}
		else result[prop] = src;
	}
	else if (_.last(src) === '%') result[prop] = _transferPercent(src);
	else result[prop] = src;
	return result;
};

export class Dialog extends Box {
	static version = '1.1.1';
	static propTypes = {
		...Box.propTypes,
		ico: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		icoWeight: PropTypes.oneOf(['normal', 'bold']),
		title: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
		isFooter: PropTypes.bool,
		isDraggable: PropTypes.bool,
		isOk: PropTypes.bool,
		isClose: PropTypes.bool,
		onOk: PropTypes.func,
		okText: PropTypes.string,
		isCancel: PropTypes.bool,
		onCancel: PropTypes.func,
		cancelText: PropTypes.string,
	};
	static defaultProps = {
		...Box.defaultProps,
		modal: 'gray',
		closeByESC: false,
		closeByClickDocument: false,
		ico: false,
		icoWeight: 'normal',
		title: '104 HR Max',
		isHeader: true,
		isFooter: true,
		isDraggable: true,
		isOk: true,
		isClose: false,
		okText: OptionUtils.getLabel('global.normal', 'sure'),
		workingText: OptionUtils.getLabel('components.Dialogs', 'processing'),
		isCancel: true,
		cancelText: OptionUtils.getLabel('global.normal', 'cancel'),
		width: 'sd',
		openFx: 'an-zoomInEnlarge',
	};
	state = {
		... this.state,
		working: false,
		loading: false,
		data: null,
	};
	fakeDiv = document.createElement('div');

	constructor(props) {
		super(props);
		const { theme, className } = this.props;
		this._props = {
			theme: `dialog -v2 ${theme ? theme : ''}`,
		};
	}

	static getDerivedStateFromProps(props, state) {
		const { working, loading, isFooter, bodyStyle } = props;
		const { _working, _loading, _isFooter, _bodyStyle } = state;
		let s = {};
		if (working !== _working) {
			s._working = working;
			s.working = working;
		}
		if (loading !== _loading) {
			s._loading = loading;
			s.loading = loading;
		}
		if (isFooter !== _isFooter) {
			s._isFooter = isFooter;
			s.isFooter = isFooter;
		}
		if (_.isEqual(bodyStyle, _bodyStyle)) {
			s._bodyStyle = bodyStyle;
			s.bodyStyle = bodyStyle;
		}
		return s;
	}

	componentDidMount() {
		super.componentDidMount();
		const { isDraggable } = this.props;
		const { head: h } = this._dom;
		if (isDraggable && h)
			new Drag.Move(this._dom.wrapper, { handle: h, container: document.body });
	}

	renderTitle() {
		return this.props.title;
	}

	renderHeaderExtension() {
		return null;
	}

	renderTopSticky() {
		const { renderTopSticky } = this.props;
		return renderTopSticky ? (_.isFunction(renderTopSticky) ? renderTopSticky() : renderTopSticky) : null;
	}

	renderFooter() {
		const {
			renderFooter: footer, close,
			isOk, onOk, okText, workingText, isCancel, onCancel, cancelText,
		} = { ...this.props, ...this._props };
		const { working, isSubmitting } = this.state;
		return footer ? (_.isFunction(footer) ? footer() : footer) : <>
			{isCancel ? <span {... {
				className: 'btn btn-primary',
				onClick: evt => {
					if (_.isFunction(onCancel)) onCancel();
					close();
				},
			}}>{cancelText}</span> : null}
		</>;
	}

	renderBoxBody() {
		const { bodyClassName, bodyStyle, ico, bgIco, icoWeight, close, loadApi, isHeader , isClose, isDraggable, icoImg, titleStyle, width } = {
			... this.props,
			... this._props,
		};
		let currentWidth = _calWidth(width)?.width;
		const { loading, working, isFooter, extraBody, data } = this.state;

		return <>
			{isHeader ? <div ref={ele => this._dom.head = ele} className={`-header${isDraggable ? ' draggable' : ''}`} >
				<span className={'-title'} style={titleStyle || {}}>
					{ico ? <i className={`${icoWeight === 'normal' ? 'fal' : 'fa'} fa-fw fa-${ico}`} /> : null}
					{icoImg ? <img src={icoImg} width="30"/> : null}
					{' '}{this.renderTitle()}
				</span>
				{this.renderHeaderExtension()}
				{isClose && <span {... {
					className: `-close fal fa-times${working ? ' disable' : ''}`,
					onClick: working ? null : evt => close(),
				}} />}
			</div> : null}
			{this.renderTopSticky()}
			<div {... {
				ref: ele => this._dom.body = ele,
				className: `-body ${bodyClassName ? bodyClassName : ''}`,
				...bodyStyle ? { style: bodyStyle } : null,
			}}>
				{!loadApi ? this.renderBody(data) : loading ? <Loading size={'lg'} /> : data ? this.renderBody(data) : null}
				{_.isFunction(this.renderExtraBody) ? this.renderExtraBody() : null}
			</div>
			{bgIco ? <i className={`-bg fa fa-${bgIco}`} /> : null}
			{isFooter ? <div className={'-footer'}>{this.renderFooter()}</div> : null}
		</>;
	}

	render() {
		const { className, theme, width, height, level, modal, style, openFx, inject, wrapperStyle, isRDate } = {
			... this.props,
			... this._props,
		};
		let currentWidth = _calWidth(width)?.width;
		let isOverWidth = getOverWidth(currentWidth);

		const _renderPointer = () => {
			const { pointerClassName: css, pointerStyle: s } = this.props;
			const { pointerDirection } = this.state;
			return pointerDirection ? <span {... {
				ref: ele => this._dom.pointer = ele,
				className: `pointer-${pointerDirection}` + (css ? ` ${css}` : ''),
				...s ? { style: s } : null
			}} /> : null;
		};

		const box = <>
			<div {... {
				ref: ele => this._dom.box = ele,
				className: (() => {
					let css = 'H2-Box';
					css += modal ? ` modal${this.context ? ' -mobile' : ''}` : '';
					css += _.isString(modal) ? ` ${modal}` : '';
					css += theme ? ` ${theme}` : '';
					return css;
				})(), style,
			}}>
				<MobileContext.Consumer>
					{(isMobile) => {
						return (
							<div {... {
								ref: ele => {
									this._dom.wrapper = ele;
								},
								className: classnames('-wrapper', {
									openFx: openFx,
									className: className,
									'-mobile': isMobile,
									'-out-position': isMobile || isOverWidth
								}),
								style: {
									...width ? _calWidth(width) : null,
									...height ? _calLength(height, 'height') : null,
									...level > 1 ? { zIndex: level + 100 } : null,
									...isOverWidth ? {
										width: '98vw',
										position: 'initial',
									} : null,
									...isMobile ? {
										width: '100vw',
										borderRadius: 0,
										position: 'initial',
									} : null,
									wrapperStyle,
								},
							}}>{this.renderBoxBody()}{_renderPointer()}</div>
						);
					}}
				</MobileContext.Consumer>
				{this.renderExtra()}
			</div>
			{this.renderConfirm()}
		</>;
		return inject ? ReactDOM.createPortal(box, inject) : box;
	}
}
